import *as React from 'react'

import "./downloas.scss"

interface DownloadProps {
    id: string;
    clientCode: string;
    siteId: number;
    type: string;
}

export function Download({ id, clientCode, siteId, type }: DownloadProps) {

    const download = ()=>{
        let date = new Date()
        let text = document.getElementById(id).innerText
        const filename = `exports_${type}_${clientCode}_${siteId}_${date.getDate()}-${date.getMonth()}-${date.getFullYear()}.csv`

        var element = document.createElement('a');
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
        element.setAttribute('download', filename);
      
        element.style.display = 'none';
        document.body.appendChild(element);
      
        element.click();
      
        document.body.removeChild(element);

    }

    return (
        <div className="bottom">
            <button onClick={download}>Télécharger le csv</button>
        </div>


    )
}
